import React from 'react';
import {
  Container,
  Box,
  Typography,
  List,
  ListItem,
  Button
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ReactComponent as LinkedInIcon } from '../../assets/linkedin.svg';
import { ReactComponent as EmailIcon } from '../../assets/email.svg';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 8, md: 10 },
        background: 'linear-gradient(180deg, #f8f9fe 0%, #ffffff 100%)',
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container columns={12} spacing={6} alignItems="flex-start">
          <Grid gridColumn="span 12 span 4@md">
            <Box sx={{
              mb: { xs: 4, md: 0 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              position: 'static',
              backgroundColor: 'transparent'
            }}>
              <Typography variant="body1" sx={{
                color: '#546E7A',
                fontSize: '1.1rem',
                lineHeight: 1.6,
                mb: 3,
                maxWidth: '400px'
              }}>
                Helping businesses understand what customers really think and take action to make them happier.
              </Typography>
            </Box>
          </Grid>
          <Grid gridColumn="span 12 span 8@md">
            <Grid container columns={12} spacing={4}>
              <Grid gridColumn="span 6">
                <Typography variant="subtitle1" sx={{
                  fontWeight: 700,
                  color: '#0A2540',
                  mb: 3,
                  textAlign: { xs: 'left', md: 'center' }
                }}>
                  Quick Links
                </Typography>
                <List sx={{
                  p: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: { xs: 'flex-start', md: 'center' }
                }}>
                  <ListItem sx={{ p: 0, mb: 2 }}>
                    <Button
                      component="a"
                      href="#features"
                      sx={{
                        color: '#546E7A',
                        p: 0,
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: '#1976d2',
                          transform: 'translateX(4px)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      Features
                    </Button>
                  </ListItem>
                  <ListItem sx={{ p: 0, mb: 2 }}>
                    <Button
                      component="a"
                      href="/about"
                      sx={{
                        color: '#546E7A',
                        p: 0,
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: '#1976d2',
                          transform: 'translateX(4px)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      About
                    </Button>
                  </ListItem>
                </List>
              </Grid>
              <Grid gridColumn="span 6">
                <Typography variant="subtitle1" sx={{
                  fontWeight: 700,
                  color: '#0A2540',
                  mb: 3,
                  textAlign: { xs: 'left', md: 'center' }
                }}>
                  Contact Us
                </Typography>
                <List sx={{
                  p: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: { xs: 'flex-start', md: 'center' }
                }}>
                  <ListItem sx={{ p: 0, mb: 2 }}>
                    <Button
                      sx={{
                        color: '#546E7A',
                        p: 0,
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: '#1976d2',
                          transform: 'translateX(4px)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                      href="mailto:info@sashy.ai"
                    >
                      Get Support
                    </Button>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        
        <Box sx={{
          mt: 8,
          pt: 4,
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}>
          {/* Creator Information Section */}
          <Box sx={{
            mb: 6,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: 4,
            p: 3,
            borderRadius: '16px',
            background: 'linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(25, 118, 210, 0.02) 100%)'
          }}>
            <Box sx={{
              width: { xs: '150px', md: '180px' },
              height: { xs: '150px', md: '180px' },
              borderRadius: '50%',
              overflow: 'hidden',
              border: '3px solid #1976d2',
              boxShadow: '0 8px 24px -8px rgba(25, 118, 210, 0.4)'
            }}>
              <img
                src="/robert.jpg"
                alt="Robert Whiteley"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/180?text=Robert";
                }}
              />
            </Box>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              textAlign: { xs: 'center', md: 'left' }
            }}>
              <Typography variant="h5" sx={{
                mb: 2,
                fontWeight: 700,
                color: '#0A2540'
              }}>
                Robert Whiteley, Founder
              </Typography>
              <Typography variant="body1" sx={{
                color: '#546E7A',
                fontSize: '1.1rem',
                lineHeight: 1.6,
                mb: 3
              }}>
                Having worked at the intersection of business development and AI, we created Sashy to solve a common challenge: truly understanding and improving the customer experience. Manually analyzing feedback is overwhelming, yet it holds the key to growth.
                <br /><br />
                Our mission is to empower businesses like yours with the tools to easily decode customer sentiment from reviews, identify critical experience drivers, and take targeted actions. Sashy is your partner in building stronger customer relationships and a better business.
              </Typography>
              <Box sx={{
                display: 'flex',
                gap: 2,
                mt: 1,
                justifyContent: { xs: 'center', md: 'flex-start' }
              }}>
                <Box
                  component="a"
                  href="mailto:info@sashy.ai"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#1976d2',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      transition: 'transform 0.2s ease'
                    }
                  }}
                >
                  <EmailIcon style={{ width: '28px', height: '28px' }} />
                </Box>
                <Box
                  component="a"
                  href="https://www.linkedin.com/company/sashy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#0077B5',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      transition: 'transform 0.2s ease'
                    }
                  }}
                >
                  <LinkedInIcon style={{ width: '28px', height: '28px' }} />
                </Box>
              </Box>
            </Box>
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2
          }}>
            <Typography variant="body2" sx={{
              color: '#78909C',
              fontSize: '0.95rem'
            }}>
              © {new Date().getFullYear()} Sashy. All rights reserved.
            </Typography>
            <Box sx={{ display: 'flex', gap: 3 }}>
              <Button
                sx={{
                  color: '#78909C',
                  p: 0,
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#1976d2'
                  }
                }}
                href="/privacy"
              >
                Privacy Policy
              </Button>
              <Button
                sx={{
                  color: '#78909C',
                  p: 0,
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#1976d2'
                  }
                }}
                href="/terms"
              >
                Terms of Service
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 